<template>
  <div class="textarea">
    <textarea :placeholder="defaulttext" @input="inputFn" v-model="values" maxlength="60">{{values}}</textarea>
  </div>
</template>

<script>
  export default {
    name: 'xk-textarea',
    props: {
      value: String,
      defaulttext: String
    },
    data () {
      return {
        values: this.value
      }
    },
    methods: {
      inputFn: function () {
        this.$emit('input', this.values)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .textarea {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border: 1px solid #d3d3d4;
    padding: 0.5rem;
    border-radius: 0.333rem;
    overflow: hidden;
    textarea {
      border: none;
      resize: none;
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// textarea.vue?58083670